<template>
  <div class="map_control_2">
    <div class="list_box scenic_list_box">
      <DrawerPop
        :list="regions || []"
        @select="mapSelect"
        ref="mapPop"
      ></DrawerPop>
    </div>
    <div class="map_control_box one_left">
      <div class="decorate right"></div>
      <div @click="showMapPop" class="item">
        <div class="text">
          {{ regionsSelect.name }}
        </div>
        <div class="iconfont iconarrow-down-bold"></div>
      </div>
    </div>
    <div class="angle">
      <div class="decorate left"></div>
      <div class="decorate right"></div>
    </div>
    <div class="map_control_box two child">
      <div class="decorate left"></div>
      <div class="decorate right"></div>
      <div
        @click="() => controlBridge({ type: 'map', value: 'map', state: true })"
        :class="['item', showType === 'map' && 'is_selected']"
      >
       2D
      </div>
      <!-- 〡
      <div
        @click="
          () => controlBridge({ type: 'map', value: 'twod', state: true })
        "
        :class="['item', showType === 'twod' && 'is_selected']"
      >
        2D
      </div> -->
      〡
      <div
        @click="
          () => controlBridge({ type: 'map', value: 'threed', state: true })
        "
        :class="['item', showType === 'threed' && 'is_selected']"
      >
        3D
      </div>
      <!-- 〡
            <div @click="()=> controlBridge({type: 'map', value: 'draw', state: true})" class="item"> 手绘 </div> -->
    </div>
    <div class="angle">
      <div class="decorate left"></div>
      <div class="decorate right"></div>
    </div>
    <div class="list_box grid_list_box">
      <DrawerPop
        :list="gridTypes"
        @select="gridSelect"
        ref="gridPop"
      ></DrawerPop>
    </div>
    <div class="map_control_box two child">
      <div class="decorate left"></div>
      <div class="decorate right"></div>
      <div
        @click="
          () =>
            controlBridge({ type: 'marker', value: 'hot', state: !isHotMap })
        "
        :class="['item', isHotMap && 'is_selected']"
      >
        热力图
      </div>
      〡
      <div
        @click="
          () =>
            controlBridge({ type: 'marker', value: 'bound', state: !isBound })
        "
        :class="['item', isBound && 'is_selected']"
      >
        边界
      </div>
      〡
      <div @click="showGridPop" class="item">
        <div class="text">
          {{ gridTypeSelect.name }}
        </div>
        <div class="iconfont iconarrow-down-bold"></div>
      </div>
    </div>
    <div class="angle">
      <div class="decorate left"></div>
      <div class="decorate right"></div>
    </div>
    <div class="map_control_box one_right child">
      <div class="decorate left"></div>
      <div
        @click="() => controlBridge({ type: 'fun', value: 'center' })"
        class="item"
      >
        <div class="iconfont icondingwei"></div>
      </div>
      〡
      <div
        @click="() => controlBridge({ type: 'fun', value: 'direction' })"
        class="item"
      >
        <div class="iconfont iconzhinanzhen"></div>
      </div>
    </div>
  </div>
</template>

<script>
import DrawerPop from "./DrawerPop";
export default {
  props: {
    gridTypes: {
      type: Array,
      default: [{ name: "网格OFF", type: "off" }],
    },
    regions: {
      type: Array,
      default: [{ name: "区域", type: "off" }],
    },
  },
  data() {
    return {
      regionIndex: 0,
      gridTypeIndex: 0,
      showType: "threed",
      isHotMap: false,
      isBound: false,
    };
  },
  computed: {
    regionsSelect({ regions, regionIndex }) {
      return regions ? regions[regionIndex] : {name:"区域"};
    },
    gridTypeSelect({ gridTypes, gridTypeIndex }) {
      return gridTypes ? gridTypes[gridTypeIndex] : {name:"网格OFF"};
    },
  },
  methods: {
    controlBridge({ type, value, index = undefined, state }) {
      const that = this;
      const methods = {
        mapType: {
          default() {},
        },
        map: {
          map() {
            that.showType = value;
          },
          twod() {
            that.showType = value;
          },
          threed() {
            that.showType = value;
          },
          draw() {
            that.showType = value;
          },
        }, 
        marker: {
          hot() {
            that.isHotMap = state;
          },
          bound() {
            that.isBound = state;
          },
        },
        grid: {
          default() {},
          off() {},
        },
        fun: {
          center() {},
          direction() {},
        },
      };
      if (methods[type].hasOwnProperty(value)) {
        methods[type][value]();
      } else {
        methods[type].default();
      }
      this.$emit("control", { type, value, index, state });
    },
    showMapPop() {
      !this.$refs.mapPop.isShow
        ? this.$refs.mapPop.show()
        : this.$refs.mapPop.hide();
    },
    mapSelect({ index }) {
      this.regionIndex = index;
      const value = this.regions[this.regionIndex].id;
      this.controlBridge({ type: "mapType", value, index, state: true });
    },
    showGridPop() {
      console.log("gridPop");
      !this.$refs.gridPop.isShow
        ? this.$refs.gridPop.show()
        : this.$refs.gridPop.hide();
    },
    gridSelect({ index }) {
      this.gridTypeIndex = index;
      const value = this.gridTypes[this.gridTypeIndex].code;
      console.log("gridSelect");
      this.controlBridge({ type: "grid", value, index, state: true });
    },
  },
  components: {
    DrawerPop,
  },
};
</script>

<style lang="scss" scoped>
@import url("../../../../font/iconfont.css");
.map_control_2 {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  position: absolute;
  right: 1%;
  bottom: 16px;
  .angle {
    position: relative;
    margin-left: -12px;
    width: 20px;
    height: 10px;
    border-bottom: 1px solid #2bc2ff;
    overflow: hidden;
    .decorate {
      position: absolute;
      border-bottom: 1px solid #2bc2ff;
      width: 20px;
    }
    .left {
      transform: rotate(-45deg);
      left: -6px;
      top: 5px;
    }
    .right {
      transform: rotate(45deg);
      right: -6px;
      top: 5px;
    }
  }
  .list_box {
    position: absolute;
    z-index: 10001;
  }
  .scenic_list_box {
    left: 4px;
    top: 0;
    width: 82px;
  }
  .grid_list_box {
    right: 80px;
    top: 0;
    width: 82px;
  }
  .one_left {
    margin-left: 0 !important;
    clip-path: polygon(0 0, 100% 0, 100% 26px, calc(100% - 10px) 36px, 0 36px);
  }
  .two {
    clip-path: polygon(
      0 0,
      100% 0,
      100% 26px,
      calc(100% - 10px) 36px,
      10px 36px,
      0 26px
    );
  }
  .one_right {
    margin-right: 0 !important;
    clip-path: polygon(0 0, 100% 0, 100% 100%, 10px 36px, 0 26px);
  }
  .map_control_box {
    display: flex;
    align-items: center;
    position: relative;
    height: 36px;
    background-color: rgba(15, 36, 69, 0.8);
    border: solid 1px #2bc2ff;
    box-sizing: border-box;
    list-style: none;
    margin: 0 4px;
    padding: 0 16px 0 20px;
    overflow: hidden;

    .decorate {
      position: absolute;
      border-bottom: 1px solid #2bc2ff;
      width: 16px;
    }
    .left {
      transform: rotate(45deg);
      left: -3px;
      top: 30px;
    }
    .right {
      transform: rotate(-45deg);
      right: -3px;
      bottom: 3px;
    }
    .item {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #6f8797;
      background-repeat: no-repeat;
      background-size: auto 14px;
      background-position: left center;
    }
    .is_selected {
      color: #2bc2ff;
    }
    .iconfont {
      color: #3e5565;
    }
  }
  .child {
    margin-left: -8px;
    padding: 14px;
  }
}
</style>